export default "<p>rate works!</p>\n"